export default __webpack_public_path__ + "static/media/tihomir.fac02887.jpg";